/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventParty,
    JsonEventPartyFromJSON,
    JsonEventPartyFromJSONTyped,
    JsonEventPartyToJSON,
} from './JsonEventParty';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventParty
 */
export interface ApiResultOfJsonEventParty {
    /**
     * 
     * @type {JsonEventParty}
     * @memberof ApiResultOfJsonEventParty
     */
    data?: JsonEventParty;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventParty
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventParty
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventParty
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventParty
     */
    result?: ApiResultOfJsonEventPartyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyFromJSON(json: any): ApiResultOfJsonEventParty {
    return ApiResultOfJsonEventPartyFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventParty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyToJSON(value?: ApiResultOfJsonEventParty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

